<template>
  <page-template type="norightpanel">
    <template v-slot:toolbar>
      <tool-bar type="results" title="Nom enquête" linkback="/enquetes" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="mx-8 results-enquete detail">
        <div class="d-flex justify-space-between pa-4 results-header">
          <p>Réponses : <strong>2</strong></p>
        </div>
        <v-row class="ma-0 results-content">
          <v-col class="col-3 tenants-list">
            <h5 class="px-4 py-2">Votants</h5>
            <div class="d-flex flex-column cursor-pointer px-4 py-2 tenant-info active">
              <p>Nom du locataire</p>
              <p>26/09/2021 - 14:47</p>
            </div>
            <div class="d-flex flex-column cursor-pointer px-4 py-2 tenant-info">
              <p>Nom du locataire</p>
              <p>26/09/2021 - 14:47</p>
            </div>
          </v-col>
          <v-col class="col-9 px-8 answers-detail">
            <div class="pb-6 tenant-info">
              <p><strong>Nom du locataire</strong></p>
              <p>ID du locataire</p>
              <p>26/09/2021 - 14:47</p>
            </div>
            <div class="pb-6">
              <p class="text-uppercase">1. Question 1</p>
              <p><strong>Réponse</strong></p>
            </div>
            <div class="pb-6">
              <p class="text-uppercase">1. Question 1</p>
              <p><strong>Réponse</strong></p>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'EnquetesResultatDetail',
    components: { pageTemplate, toolBar },
    data: () => {
      return {}
    },
    async created () {
      try {
        // DETAIL RESPONSES OF A FINISHED POLL
        const pollDetailResponsesRes = await axios.get(`${apiURL}/polls/response/[:userId]/[:IdPoll]`)
        this.pollDetailResponses = pollDetailResponsesRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>